export default "__VITE_ASSET__01f5c560__"